var random1199 = {
    // COGS: 0.68,
    // msrp: 12.95,
    image: 'https://pickaxes.coinapp.co/images/unrevealed/500x500.png',
    planId: 'random-mint-11-99',
    amount: 11.99,
    quantity: 1,
    maxQuantity: 10,
    subtitle: "Common, Uncommon (1/100), Rare (1/1k), Epic (1/10k), Legendary (1/100k)<br><em>Note: The Premium Plans Item Boost Enhancement doesn't apply to Random Mints.</em>",
    name: 'Mint Random Pickaxe',
    // value: 12.95,
};
export var pickaxeItems = {
    random1199: random1199,
};
//# sourceMappingURL=Pickaxe.js.map